var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTiickerLogo = function SvgTiickerLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "auto",
    viewBox: "0 0 142 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tiicker-logo_svg__a",
    d: "M.274.033h24.757v28.644H.274z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#85BB63",
    d: "M27.29 7.234v6.256l6.396-6.256zm-8.622 8.094v6.256l6.396-6.256zm.176 8.541v6.184h6.22V17.691zm8.658-7.988v14.171h6.22V9.692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414142",
    d: "M91.009 1.25v28.645h21.812v-5.607h-15.55v-2.313h-.001V9.478h.001V6.855h15.346V1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414142",
    d: "M98.815 18.272h11.96v-5.607h-11.96zM0 1.409v5.81h8.716v22.833h6.302V7.219h8.717v-5.81zM61.36 19.747l-3.754 2.78c-1.83 1.287-3.655 2.205-6.23 2.205-4.91 0-8.307-4.093-8.307-9.003v-.082c-.001-4.91 3.477-8.92 8.307-8.92 1.944 0 3.654.507 5.74 2.314l4.337-4.335c-2.66-2.617-5.867-3.79-10.036-3.79-8.8.001-14.934 6.671-14.934 14.814v.082c0 8.225 6.26 14.73 14.689 14.73 4.576 0 7.608-1.35 10.188-3.605v-7.19z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.722 1.375)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tiicker-logo_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tiicker-logo_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#414142",
    d: "M18.034 18.446c3.642-1.35 6.137-4.255 6.137-8.879v-.082c0-2.7-.858-4.951-2.453-6.548C19.834 1.055 17.01.033 13.368.033H.275v28.644H6.57V11.393h.005V5.72h6.261c3.07 0 4.952 1.39 4.952 4.092v.081c0 2.413-1.76 4.051-4.83 4.051H8.116v5.564h3.413l6.138 9.168h7.366l-6.998-10.231z",
    mask: "url(#tiicker-logo_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#414142",
    d: "M81.469 1.409 69.847 13.927V1.409h-6.301v28.643h6.301V21.54L89.081 1.409z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414142",
    d: "m74.166 19.237 7.876 10.815h7.571L78.349 14.821z"
  }))));
};

export default SvgTiickerLogo;